import { useSelector, useDispatch } from 'react-redux';
import { 
  setTheme, toggleDarkMode, setSidebarSize, setSidebarColor, setLayoutWidth, 
  setLayoutPosition, resetTheme, toggleNovuDropdown, setNovuDarkMode
} from '../slices/themeSlice';

export const useTheme = () => {
  const dispatch = useDispatch();
  const theme = useSelector(state => state.theme);

  return {
    theme,
    setTheme: (themeData) => dispatch(setTheme(themeData)),
    toggleDarkMode: (isDark) => dispatch(toggleDarkMode(isDark)),
    setSidebarSize: (size) => dispatch(setSidebarSize(size)),
    setSidebarColor: (color) => dispatch(setSidebarColor(color)),
    setLayoutWidth: (width) => dispatch(setLayoutWidth(width)),
    setLayoutPosition: (position) => dispatch(setLayoutPosition(position)),
    resetTheme: () => dispatch(resetTheme()),
    
    // Novu-specific theme actions
    toggleNovuDropdown: (isOpen) => dispatch(toggleNovuDropdown(isOpen)),
    setNovuDarkMode: (isDark) => dispatch(setNovuDarkMode(isDark)),
  };
};

export default useTheme;